import React from 'react'
// libs
import { InjectedFormProps, reduxForm } from 'redux-form'
// constants
import { Forms } from 'constants/index'
// components
import Grid from '@mui/material/Grid2'
import { ReduxInput, ReduxSwitch } from 'components/FormElements/ReduxForm'
import { Button, BUTTON_LAYOUTS } from 'components/UI'
// utils
import { required } from 'utils/index'

// types
interface IIncomingProps {
  hideModal: () => void
  isEdit?: boolean
}

interface IFormData {
  active: boolean
  label: string
  value: string | number
}

type IFormProps = InjectedFormProps<IFormData, IIncomingProps>

type IProps = IIncomingProps & IFormProps

// constants
const GRID_STYLE = {
  marginTop: '16px'
}

const ScaleOptionForm: React.FC<IProps> = ({ handleSubmit, hideModal, isEdit }) => {
  return (
    <form onSubmit={handleSubmit}>
      <Grid container spacing={2} direction={'column'}>
        <Grid
          size={{
            md: 12
          }}>
          <ReduxSwitch label={'Active'} name={'active'} reverse />
        </Grid>

        <Grid
          size={{
            md: 12
          }}>
          <ReduxInput label={'Label'} name={'label'} validate={required} />
        </Grid>
        <Grid
          size={{
            md: 12
          }}>
          <ReduxInput label={'Value'} name={'value'} type={'number'} validate={required} />
        </Grid>
      </Grid>
      <Grid container spacing={2} style={GRID_STYLE}>
        <Grid>
          <Button layout={BUTTON_LAYOUTS.PURPLE} type={'submit'} shadowLess>
            {isEdit ? 'Edit' : 'Add'}
          </Button>
        </Grid>
        <Grid>
          <Button layout={BUTTON_LAYOUTS.PURPLE_INVERTED} onClick={hideModal} type={'button'} shadowLess>
            Cancel
          </Button>
        </Grid>
      </Grid>
    </form>
  )
}

export default reduxForm<IFormData, IIncomingProps>({
  form: Forms.SCALE_OPTION_DETAILS_FORM,
  enableReinitialize: true
})(ScaleOptionForm)
